import React, { useEffect, useState } from "react";
import TableDataLayer from "../components/TableDataLayer";
import { Icon } from "@iconify/react/dist/iconify.js";
import { apiCall } from "../utils/apiService";
import "./ListPage.css";

const TemplateLayer = () => {
    const [data, setData] = useState(0);
    const [rows, setRows] = useState([]);

    const fetchTemplates = async () => {
        try {
            const response = await apiCall({
                url: `templet/get-templet`,
                method: "POST",
                body: { type: "all" },
            });
            setData(response.total);
            setRows(Array.isArray(response.data) ? response.data : []);
            return response;
        } catch (error) {
            console.error("Error fetching templates:", error);
            return { data: [], total: 0 };
        }
    };

    const removeTemplate = async (id) => {
        try {
            const response = await apiCall({
                url: `templet/delete-templet`,
                method: "POST",
                body: { id },
            });
            if (response.success) {
                setData((n) => Math.max(0, Number(n) - 1));
            }
        } catch (error) {
            console.error("Error deleting template:", error);
        }
    };

    const typeCounts = rows.reduce(
        (acc, row) => {
            const t = String(row.type || "other").toLowerCase();
            if (t.includes("text")) acc.text += 1;
            else if (t.includes("media") || t.includes("image") || t.includes("video") || t.includes("audio"))
                acc.media += 1;
            else acc.other += 1;
            return acc;
        },
        { text: 0, media: 0, other: 0 }
    );

    const columns = [
        { key: "id", label: "ID" },
        {
            key: "name",
            label: "Name",
            render: (val) => <span className="fw-semibold">{val || "Untitled"}</span>,
        },
        {
            key: "type",
            label: "Type",
            render: (val) => <span className="list-type">{val || "—"}</span>,
        },
        {
            key: "createdAt",
            label: "Created",
            render: (val, row) => {
                const date = new Date(row.createdAt);
                if (Number.isNaN(date.getTime())) return "—";
                return date.toLocaleDateString(undefined, {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                });
            },
        },
        {
            key: "actions",
            label: "Actions",
            render: (val, row) => (
                <button
                    type="button"
                    onClick={() => removeTemplate(row.id)}
                    className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center border-0"
                >
                    <Icon icon="mingcute:delete-2-line" />
                </button>
            ),
        },
    ];

    useEffect(() => {
        document.title = "Templates";
    }, []);

    return (
        <>
            <div className="list-kpi-row">
                <div className="card list-kpi templates">
                    <div className="list-kpi-body">
                        <div>
                            <p className="list-kpi-label">Total templates</p>
                            <h6 className="list-kpi-value">{Number(data) || rows.length || 0}</h6>
                        </div>
                        <div className="list-kpi-icon">
                            <Icon icon="mdi:file-document-multiple-outline" />
                        </div>
                    </div>
                </div>
                <div className="card list-kpi books">
                    <div className="list-kpi-body">
                        <div>
                            <p className="list-kpi-label">Text</p>
                            <h6 className="list-kpi-value">{typeCounts.text}</h6>
                        </div>
                        <div className="list-kpi-icon">
                            <Icon icon="mdi:message-text-outline" />
                        </div>
                    </div>
                </div>
                <div className="card list-kpi contacts">
                    <div className="list-kpi-body">
                        <div>
                            <p className="list-kpi-label">Media</p>
                            <h6 className="list-kpi-value">{typeCounts.media}</h6>
                        </div>
                        <div className="list-kpi-icon">
                            <Icon icon="mdi:image-outline" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="card basic-data-table list-card">
                <div className="card-header">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                        <div>
                            <h5 className="card-title mb-0">Template library</h5>
                            <p className="mb-0 text-secondary-light text-sm">
                                Saved text and media templates for faster sending
                            </p>
                        </div>
                    </div>
                </div>
                <TableDataLayer columns={columns} totalRows={data} fetchData={fetchTemplates} />
            </div>
        </>
    );
};

export default TemplateLayer;
